<div *ngIf="vm$ | async as vm">

  <!-- BOTÃO FIXO -->
  <button class="chat-button" (click)="toggle(); $event.stopPropagation()" *ngIf="!vm.isOpen">
    <i class="pi pi-comment"></i> Suporte
  </button>

  <!-- CHAT -->
  <div
    class="chat-container"
    [@chatAnimation]="vm.isOpen ? 'open' : 'closed'"
    *ngIf="vm.isOpen"
  >

    <!-- HEADER -->
    <div class="chat-header">
      <span><i class="pi pi-comment"></i> Suporte Splitpay</span>
      <button class="close-btn" (click)="close()">✕</button>
    </div>

    <!-- CONTEÚDO -->
    <div class="chat-body">
      <h3>Olá, como podemos ajudar?</h3>
      <p>Fale com nossa equipe ou acesse os tutoriais abaixo.</p>

      <!-- CTA -->
      <button class="whatsapp-btn" (click)="openWhatsApp()">
        <i class="pi pi-whatsapp "></i> Falar no WhatsApp
      </button>

      <!-- TUTORIAIS -->
      <div class="profiles">
        <span> TUTORIAIS POR PERFIL </span>

        <div class="chips">
          <button (click)="selectProfile('secretaria')">Secretária</button>
          <button (click)="selectProfile('gestor')">Gestor</button>
          <button (click)="selectProfile('profissional')">Parceiro</button>
        </div>
      </div>
    </div>

  </div>
</div>